import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MATERIAL_THUMBNAIL_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "camira" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_ARTICLE_ID$_$MATERIAL_NAME$_Tileable Image.$IMAGE_FORMAT$",
        options,
    },

    // thumbnails
    ...MATERIAL_THUMBNAIL_TYPE.map((type) => ({
        type,
        schema: "$MATERIAL_ARTICLE_ID$_$MATERIAL_NAME$_Thumbnail_$MATERIAL_THUMBNAIL_SIZE_PX$px.$IMAGE_FORMAT$",
        options,
    })),
]
